export enum ColumnPublisherAbbreviation {
  FORUM = 'FCC',
  LEE = 'LEE',
  SEATON = 'STN'
}
